<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
          >
            <el-form-item label="编号" prop="batchVerificationDetailId">
              <el-input
                v-model="searchForm.batchVerificationDetailId"
                size="small"
                clearable
                type="number"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="订单号" prop="orderNo">
              <el-input
                v-model="searchForm.orderNo"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户名称" prop="userName">
              <el-input
                v-model="searchForm.userName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select v-model="searchForm.status" size="small" clearable @change="onSearch">
                <el-option v-for="item in status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="参与时间"
              prop="updatedTime"
            >
              <el-date-picker
                class="date-input"
                size="small"
                v-model="searchForm.updatedTime"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="-"
                start-placeholder="起始时间"
                end-placeholder="截至时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportList">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="multipleTable"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="batchVerificationDetailId" label="编号" align="center" width="120"></el-table-column>
          <el-table-column prop="orderNo" label="订单号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="userName" label="用户名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="joinDate" label="参与时间" align="center" width="150"></el-table-column>
          <el-table-column prop="activityId" label="活动id" align="center" width="140"></el-table-column>
          <el-table-column prop="activityName" label="活动名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="amount" label="金额(元)" align="center"  width="140"></el-table-column>
          <el-table-column prop="statusExcel" label="状态" align="center" width="120"></el-table-column>
          <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        batchVerificationDetailId: '',
        orderNo: '',
        userName: '',
        updatedTime: [],
      },
      status: [ 
        {value: '', label: '全部'},
        {value: 0, label: '待处理'},
        {value: 1, label: '成功'},
        {value: 2, label: '失败'},
      ],
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      multipleSelection: []
    };
  },
  computed: {
    batchVerificationId() {
      return this.$route.query.batchVerificationId
    }
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
          batchVerificationId: this.batchVerificationId
        },
      };
      this.$api.dataReport
        .queryBatchVerificationDetailList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {
        batchVerificationId: this.batchVerificationId
      };
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === "updatedTime" && val) {
          this.filterParam.joinDateStart = val[0] || "";
          this.filterParam.joinDateEnd = val[1] || "";
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    exportList() {
      let params = {
        ...this.filterParam,
        batchVerificationId: this.batchVerificationId
      };
      this.$api.common.doExport("queryBatchVerificationDetailList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  filters: {},
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}
  .tips {
    margin-top: 10px;
  }

</style>
